module.exports = __webpack_public_path__ + "static/media/05_highpoint-coquitlam.5903d518.jpg";